import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject, map } from 'rxjs';
import { InviteDto } from 'src/app/components/invite-form/inviteDto.model';
import { config } from 'src/app/config/api.config';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { Activity } from 'src/app/model/Avtivity';
import { Manager } from 'src/app/model/Manager';
import { UpdateUser } from 'src/app/model/UpdateUser.model';
import { Beneficiary } from 'src/app/model/beneficiary.model';
import { Cities } from 'src/app/model/cities';
import { Countries } from 'src/app/model/countries';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { CusstomResponseDTO } from 'src/app/model/dto/custom-response';
import { Login } from 'src/app/model/login.model';
import { UpdatedBeneficiary } from 'src/app/model/updateBeneficiary.model';
import { UpdateProfil } from 'src/app/model/updateProfil';
import { Utilisateur } from 'src/app/model/userPostgres.model';
import { PresenceDTO } from '../../agenda/components/models/presence.model';
import { Statistics } from '../../main-layout/service/main-service.service';
import { ConfirmationResponse } from 'src/app/components/bootcamp-confirmation/bootcamp-confirmation.component';
import { AttendanceResponse } from 'src/app/components/activity-attendance/activity-attendance.component';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  private dashboardCache$ = new ReplaySubject<Statistics>(1);
  private cacheLoaded = false;
  public loading = false;
  private dashboardCacheBenin$ = new ReplaySubject<Statistics>(1);
  private cacheLoadedBenin = false;
  constructor(private http: HttpClient) {}

  private buildPaginationParams(
    page: number = 0,
    size: number = 10,
  ): HttpParams {
    return new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  getDashboard(): Observable<Statistics> {
    if (!this.cacheLoaded) {
      this.loading = true;
      this.http.get<Statistics>(`${config.apiBaseUrl}/dashboard`).subscribe({
        next: (data) => {
          this.dashboardCache$.next(data);
          this.loading = false;
        },
        error: (err) => {
          console.error('Erreur chargement dashboard', err);
          this.loading = false;
        },
      });
      this.cacheLoaded = true;
    }
    return this.dashboardCache$.asObservable();
  }

  public checkUser(email: string): Observable<any> {
    return this.http
      .get<CusstomResponseDTO>(
        `${config.apiBaseUrl}/usermanager/checkUser/` + email,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  public createBeneficiary(beneficiary: Utilisateur): Observable<any> {
    return this.http
      .post<CusstomResponseDTO>(
        `${config.apiBaseUrl}/usermanager/createBeneficiary`,
        beneficiary,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  public addRoleToBeneficiary(
    beneficiaryId: string,
    roleId: number,
  ): Observable<any> {
    const params = new HttpParams()
      .set('beneficiaryId', beneficiaryId)
      .set('roleId', roleId.toString());

    return this.http.post<any>(
      `${config.apiBaseUrl}/usermanager/addRoleToBeneficiary`,
      null, // body is null because we're sending parameters in the URL
      { params },
    );
  }

  public login(login: Login): Observable<any> {
    //     Création d'un objet HttpParams pour encoder les paramètres

    return this.http.post<any>(`${config.apiBaseUrl}/usermanager/login`, login);
  }

  getCities(): Observable<Cities[]> {
    return this.http.get<Cities[]>(
      `${config.openBaseUrl}/opencontroller/cities`,
    );
  }

  getCountries(): Observable<Countries[]> {
    return this.http.get<Countries[]>(
      `${config.openBaseUrl}/opencontroller/countries`,
    );
  }

  updateBeneficiary(
    IUF: String,
    beneficiaryToUpdate: UpdatedBeneficiary,
  ): Observable<CustomResponse> {
    // console.log('last :', beneficiaryToUpdate);
    // //console.log(IUF);
    return this.http.put(
      `${config.apiBaseUrl}/beneficiary/updateBeneficiary` + `/${IUF}`,
      beneficiaryToUpdate,
    );
  }

  getBeneficiaryByIUF(IUF: String): Observable<Beneficiary> {
    return this.http.get<Beneficiary>(
      `${config.apiBaseUrl}/beneficiary/beneficiary` + `/${IUF}`,
    );
  }

  updateProfil(IUF: string, profil: UpdateProfil): Observable<any> {
    return this.http.put(
      `${config.apiBaseUrl}` + `/applicant/update/${IUF}`,
      profil,
    );
  }

  getUserByEmail(Email: string): Observable<any> {
    return this.http.get(`${config.apiBaseUrl}/user/${Email}`);
  }

  updatePassword(
    userId: string,
    userWithNewPassword: UpdateUser,
  ): Observable<any> {
    return this.http.put(
      `${config.apiBaseUrl}/user/updatePassword/${userId}`,
      userWithNewPassword,
    );
  }

  getAllApplications(): Observable<any> {
    return this.http.get<any>(`${config.apiBaseUrl}/application/All`);
  }
  getMySubmissions(iuf: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/candidature/myCandidatures/${iuf}`,
    );
  }
  getProfil(IUF: string): Observable<any> {
    return this.http.get(`${config.apiBaseUrl}` + `/applicant/${IUF}`);
  }
  getPortfolio(IUF: string): Observable<any> {
    return this.http.get<any>(`${config.apiBaseUrl}/portfolio/${IUF}`);
  }

  updatePortfolio(IUF: string, portfolio: any): Observable<any> {
    return this.http.put<any>(
      `${config.apiBaseUrl}/portfolio/update/${IUF}`,
      portfolio,
    );
  }

  getApplications(applicationId: number): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/application/${applicationId}`,
    );
  }

  getAllManagersPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<any>> {
    const params = this.buildPaginationParams(page, size);
    return this.http.get<PaginatedResponse<any>>(
      `${config.apiBaseUrl}/usermanager/All`,
      { params },
    );
  }

  getAllManagers(): Observable<any> {
    return this.http.get<any>(`${config.apiBaseUrl}/usermanager/All`);
  }

  submitApplication(candidature: any): Observable<any> {
    return this.http.post<any>(
      `${config.apiBaseUrl}/applicant/postuler`,
      candidature,
    );
  }

  resetPassword(email: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/usermanager/resetpassword/${email}`,
    );
  }

  updateUser(iuf: string, beneficiary: Manager): Observable<CustomResponse> {
    return this.http.put<CustomResponse>(
      `${config.apiBaseUrl}/usermanager/updateUser/${iuf}`,
      beneficiary,
    );
  }

  disableAccount(email: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/usermanager/disableUser/${email}`,
    );
  }

  enableAccount(email: string): Observable<any> {
    return this.http.get<any>(
      `${config.apiBaseUrl}/usermanager/enableUser/${email}`,
    );
  }

  deleteUser(iuf: string): Observable<CustomResponse> {
    return this.http.delete<any>(
      `${config.apiBaseUrl}/usermanager/deleteuser/${iuf}`,
    );
  }

  stemdInscription(studentInfo: any): Observable<CustomResponse> {
    return this.http.post<any>(
      `${config.openBaseUrl}/opencontroller/createStudentFodeMoodle`,
      studentInfo,
    );
  }

  getInviteById(idInvite: string): Observable<any> {
    return this.http.get<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/invite/${idInvite}`,
    );
  }
  getActivityById(idActivity: number): Observable<Activity> {
    return this.http.get<Activity>(
      `${config.openBaseUrl}/opencontroller/activity/${idActivity}`,
    );
  }
  confirmParticipation(
    httpOptions: { params: HttpParams },
    inviteDto: InviteDto,
  ): Observable<CustomResponse> {
    return this.http.post<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/activity/confirmation`,
      inviteDto,
      httpOptions,
    );
  }
  confirmActivityParticipation(
    iuf: string,
    activity_id?: number,
  ): Observable<ConfirmationResponse> {
    return this.http.post<ConfirmationResponse>(
      `${config.openBaseUrl}/opencontroller/activity/${activity_id}/participants/${iuf}/confirm`,
      {},
    );
  }

  checkConfirmation(idInvite: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${config.openBaseUrl}/opencontroller/activity/confirmation/check/${idInvite}`,
    );
  }
  checkJpoConfirmation(
    iuf: string,
    idActivity: number,
  ): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/activity/jpo/confirmation/check/${idActivity}/${iuf}`,
    );
  }
  checkBootcampConfirmation(
    iuf: string,
    idActivity: number,
  ): Observable<CustomResponse> {
    return this.http.get<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/activity/jpo/confirmation/check/${idActivity}/${iuf}`,
    );
  }

  getAttendanceStatus(iuf: string, idActivity: number): Observable<any> {
    return this.http.get<any>(
      `${config.openBaseUrl}/opencontroller/activity/${idActivity}/participants/${iuf}/attendance/status`,
    );
  }

  public validateAttendance(
    iuf: string,
    idActivity: number,
    securityCode: string,
    waveNumber: string | null,
  ): Observable<AttendanceResponse> {
    const body: { securityCode: string; waveNumber?: string } = {
      securityCode,
    };

    if (waveNumber) {
      body.waveNumber = waveNumber;
    }

    return this.http.post<AttendanceResponse>(
      `${config.openBaseUrl}/opencontroller/activity/${idActivity}/participants/${iuf}/attendance`,
      body,
    );
  }
  public setParticipantPresence(
    presenceInfo: PresenceDTO,
  ): Observable<CustomResponse> {
    return this.http.put<CustomResponse>(
      `${config.openBaseUrl}/opencontroller/activity/presence`,
      presenceInfo,
    );
  }
  public setParticipantPresenceQrCode(
    presenceInfo: PresenceDTO,
  ): Observable<Boolean> {
    return this.http.put<Boolean>(
      `${config.openBaseUrl}/opencontroller/activity/qrcode/presence`,
      presenceInfo,
    );
  }

  public getAllPresentInSingleActivity(
    idActivityId: number,
  ): Observable<string[]> {
    return this.http.get<string[]>(
      `${config.openBaseUrl}/opencontroller/activity/qrcode/present/all/${idActivityId}`,
    );
  }

  getStatbeninByiuf(iuf: string): Observable<any> {
    if (!this.cacheLoadedBenin) {
      this.loading = true;
      this.http
        .get<Statistics>(
          `${config.apiBaseUrl}/foreignManager/${iuf}/dashboard-complete-stats`,
        )
        .subscribe({
          next: (data) => {
            this.dashboardCacheBenin$.next(data);
            this.loading = false;
          },
          error: (err) => {
            console.error('Erreur chargement dashboard', err);
            this.loading = false;
          },
        });
      this.cacheLoadedBenin = true;
    }
    return this.dashboardCacheBenin$.asObservable();
  }
  getCohortebeninByiuf(iuf: string): Observable<any> {
    return this.http.get<string[]>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/cohortes`,
    );
  }
  getCertificatBeninbyiuf(iuf: string): Observable<any> {
    return this.http.get<string[]>(
      `${config.apiBaseUrl}/foreignManager/${iuf}/certificates/chart-data"`,
    );
  }
}
